import * as z from 'zod';
import { ImageRefSchema } from '../bildebanken.js';
export const VideoRefSchema = z.object({
    src: z.string(),
    altText: z.string(),
    posterImageSrc: z.string(),
});
export const StoredParticipantSchema = z.object({
    id: z.uuidv7(),
    maskName: z.string(),
    maskedOrderIdx: z.int().nonnegative(),
    unmaskedName: z.string().nullable(),
    imageRef: ImageRefSchema.optional(),
    costumeImageRef: ImageRefSchema.optional(),
    video: VideoRefSchema.optional(),
    guessText: z.array(z.string()).optional(),
    favoriteText: z.array(z.string()).optional(),
    createdAt: z.int(),
    updatedAt: z.int(),
    unmaskedAt: z.int().nullable(),
});
export const StoredUnmaskedParticipantSchema = StoredParticipantSchema.extend({
    unmaskedName: z.string(),
    unmaskedAt: z.int(),
});
//# sourceMappingURL=participant.js.map